const translations = {
    chemicalMix: 'Chemical Mix',
    chemicalMixIsRequired: 'Chemical Mix is required'
};

export default translations;
